<template>
  <div :class="$style.container">
    <div :class="$style.item" v-for="i in events" :key="i.id">
      <div :class="$style.top">
        <div>
          {{ i.date.substr(11, 5) }}
        </div>
        <div>{{ i.counterparty.name }}</div>
        <div :class="$style.event">{{ getEvent(i) }}</div>
        <img
          @click="$store.commit('removeActiveEvent', i.id)"
          src="/icons/medium-cross.svg"
          alt=""
        />
      </div>
      <div :class="$style.bottom">
        <div>Цель: {{ i.purpose }}</div>
        <div>Событие: {{ i.event }}</div>
      </div>
      <div :class="$style.buttons">
        <div @click="$router.push('/counterpartie/' + i.counterparty.slug)">
          Перейти к контрагенту
        </div>
        <div @click="$router.push('/event/' + i.id)">Перейти к событию</div>
      </div>
    </div>
  </div>
</template>

<script>
import FILTERS from "@/assets/constants/filters.json";
export default {
  data() {
    return {
      eventsTypes: FILTERS.events,
    };
  },
  methods: {
    getEvent(item) {
      return this.eventsTypes.find((i) => i.slug == item.event_type).title;
    },
  },
  computed: {
    events() {
      return this.$store.state.events.activeEvents;
    },
  },
};
</script>

<style lang="scss" module>
.container {
  position: fixed;
  bottom: 0.5rem;
  right: 0.5rem;
  background-color: $bg-secondary;
  width: 28rem;
  padding: 1rem;
  border-radius: 0.75rem;
  box-shadow: 0 0 0.5rem 0 $main-green;
  .item {
    margin: 0 0 1rem 0;
    padding: 0 0 1.25rem 0;
    border-bottom: 1px solid #000;
    &:last-child {
      margin: 0;
      border: none;
      padding: 0;
    }
    .top {
      display: flex;
      justify-content: space-between;
      gap: 1rem;
      margin: 0 0 0.5rem 0;
      align-items: center;
      .event {
        @include Subtitle;
      }
      img {
        cursor: pointer;
      }
    }
    .bottom {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
      @include Subtitle;
      margin: 0 0 0.5rem 0;
    }
    .buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
      div {
        background-color: $main-green;
        padding: 0.75rem 0;
        @include Body2;
        border-radius: 0.25rem;
        text-align: center;
        color: $t-white;
        cursor: pointer;
      }
    }
  }
}
</style>
